import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Facebook, Twitter, Linkedin, Instagram } from 'lucide-react';
import logo from '../../assets/logo.png';

const Footer = () => {
  return (
    <footer className="bg-slate-900 text-white pt-16 pb-8">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {/* Company Info */}
          <div>
            <Link to="/" className="inline-block mb-6">
              <img src={logo} alt="Carlos Elec. Industries" className="h-12 bg-white rounded px-2 py-1" />
            </Link>
            <p className="text-slate-400 mb-6 leading-relaxed">Leading manufacturer of high-quality electrical and electronic products. Building trust through innovation and reliability since 2017.</p>
            <div className="flex space-x-4">
              <a href="#" className="bg-slate-800 p-2 rounded-full hover:bg-orange-600 transition-colors">
                <Facebook size={20} />
              </a>
              <a href="#" className="bg-slate-800 p-2 rounded-full hover:bg-orange-600 transition-colors">
                <Twitter size={20} />
              </a>
              <a href="#" className="bg-slate-800 p-2 rounded-full hover:bg-orange-600 transition-colors">
                <Linkedin size={20} />
              </a>
              <a href="#" className="bg-slate-800 p-2 rounded-full hover:bg-orange-600 transition-colors">
                <Instagram size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-6 border-b-2 border-orange-500 inline-block pb-1">Quick Links</h3>
            <ul className="space-y-3">
              <li><Link to="/" className="text-slate-400 hover:text-orange-500 transition-colors">Home</Link></li>
              <li><Link to="/about" className="text-slate-400 hover:text-orange-500 transition-colors">About Company</Link></li>
              <li><Link to="/products" className="text-slate-400 hover:text-orange-500 transition-colors">Our Products</Link></li>
              <li><Link to="/team" className="text-slate-400 hover:text-orange-500 transition-colors">Management Team</Link></li>
              <li><Link to="/contact" className="text-slate-400 hover:text-orange-500 transition-colors">Contact Us</Link></li>
            </ul>
          </div>

          {/* Products */}
          <div>
            <h3 className="text-lg font-semibold mb-6 border-b-2 border-orange-500 inline-block pb-1">Our Products</h3>
            <ul className="space-y-3">
              <li><Link to="/products" className="text-slate-400 hover:text-orange-500 transition-colors">Industrial Capacitors</Link></li>
              <li><Link to="/products" className="text-slate-400 hover:text-orange-500 transition-colors">Fan Regulators</Link></li>
              <li><Link to="/products" className="text-slate-400 hover:text-orange-500 transition-colors">Oil-Filled Capacitors</Link></li>
              <li><Link to="/products" className="text-slate-400 hover:text-orange-500 transition-colors">Electronic Components</Link></li>
              <li><Link to="/products" className="text-slate-400 hover:text-orange-500 transition-colors">Power Solutions</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-6 border-b-2 border-orange-500 inline-block pb-1">Contact Us</h3>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <MapPin className="text-orange-500 mt-1 flex-shrink-0" size={20} />
                <span className="text-slate-400">54/C-7, Rama Road Industrial Area, Near Najafgarh Road Indl. Area, West Delhi, Delhi, 110015</span>
              </li>
              <li className="flex items-center space-x-3">
                <Phone className="text-orange-500 flex-shrink-0" size={20} />
                <span className="text-slate-400">+91 797 330 9949</span>
              </li>
              <li className="flex items-center space-x-3">
                <Mail className="text-orange-500 flex-shrink-0" size={20} />
                <a href="mailto:support@carlosonestop.com" className="text-slate-400 hover:text-orange-500 transition-colors">support@carlosonestop.com</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 pt-8 text-center text-slate-500 text-sm">
          <p>&copy; {new Date().getFullYear()} Carlos Elec. Industries. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
